import type { InvalidFieldType } from '../../branchComparisonDetails/types';

type InvalidFieldsListProps = {
    fields: InvalidFieldType[];
};

function InvalidFieldsList({ fields }: InvalidFieldsListProps) {
    if (fields.length === 0) {
        return null;
    }

    return (
        <div className="branch-comparison-details__name-list-section">
            <b>Invalid fields (EDIT branch)</b>
            <ul className="branch-comparison-details__name-list branch-comparison-details__invalid-fields">
                {fields.map((field) => (
                    <li key={`${field.descriptorId}:${field.message}`}>
                        <span className="branch-comparison-details__invalid-field-label">{field.label}</span>{' '}
                        <span className="branch-comparison-details__invalid-field-message">{field.message}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default InvalidFieldsList;
